import { useStopNFTAirdrop } from './useStopNFTAirdrop';
import { useStopTokenAirdrop } from './useStopTokenAirdrop';
export const useStopCampaign = (
  campaignAddress: string,
  campaignType: string
) => {
  // Stop Campaign

  const { stopTokenAirdrop, stopTokenAirdropState } =
    useStopTokenAirdrop(campaignAddress);
  const { stopNFTAirdrop, stopNFTAirdropState } =
    useStopNFTAirdrop(campaignAddress);

  return campaignType === 'TOKEN'
    ? [stopTokenAirdrop, stopTokenAirdropState]
    : [stopNFTAirdrop, stopNFTAirdropState];
};
